import {
  AssessmentContextSchema,
  type AssessmentContextType,
} from '@/helpers/interfaces/assessments.interface';
import type { UserWithExtraFields } from '@/helpers/interfaces/user.interface';
import { useOrganizationStore } from '@/stores/organzation.pinia';

export function checkAssessmentContext(context: AssessmentContextType | null) {
  const userFromStorage = localStorage.getItem('user') ?? null;
  const user: UserWithExtraFields = userFromStorage
    ? JSON.parse(userFromStorage)
    : null;
  if (!context) return false;
  switch (context) {
    case AssessmentContextSchema.Enum.INTERESTED_TOPIC:
      return useOrganizationStore().organizationLearningCategories.data.length
        ? user?.interestedCategories?.some(
            (e) => !e?.learningCategories?.parentCategory
          )
        : true;
    case AssessmentContextSchema.Enum.SUB_TOPIC:
      return useOrganizationStore().organizationLearningCategories.data.length
        ? user?.interestedCategories?.some(
            (e) => e?.learningCategories?.parentCategory
          )
        : true;
    case AssessmentContextSchema.Enum.LEARNING_HOURS:
      return user?.userLearningHours?.length > 0;
  }
}
